import { render, staticRenderFns } from "./DesProduct.vue?vue&type=template&id=2677e41c&scoped=true&"
import script from "./DesProduct.vue?vue&type=script&lang=ts&"
export * from "./DesProduct.vue?vue&type=script&lang=ts&"
import style0 from "./DesProduct.vue?vue&type=style&index=0&id=2677e41c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2677e41c",
  null
  
)

export default component.exports